"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WelcomePageContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const auth_1 = require("@completeanatomy/auth");
const i18n_1 = require("@completeanatomy/i18n");
const storage_1 = require("@completeanatomy/storage");
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const welcome_page_image_svg_1 = __importDefault(require("../../assets/images/welcome-page-image.svg"));
const PrimaryButton_1 = require("../../atoms/PrimaryButton/PrimaryButton");
const SecondaryButton_1 = require("../../atoms/SecondaryButton/SecondaryButton");
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const Title_1 = require("../../atoms/Title/Title");
const Progress_1 = require("../../context/Progress");
const hocs_1 = require("../../hocs");
const withDelayedAppearance_1 = require("../../hocs/withDelayedAppearance");
const hooks_1 = require("../../hooks");
const router_1 = require("../../router");
const mediaQueries_1 = require("../../styles/mediaQueries");
const SurveyPageContentTemplate_1 = require("../../templates/SurveyPageContentTemplate/SurveyPageContentTemplate");
// eslint-disable-next-line max-lines-per-function
function WelcomePageContent() {
    const { t } = (0, i18n_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [, dispatch] = (0, Progress_1.useProgress)();
    const auth = (0, auth_1.useAuth)();
    const storage = (0, storage_1.useStorageService)();
    const user = (0, user_1.useUser)();
    const userOnboarding = (0, hooks_1.useUserOnboarding)();
    const [isContinueButtonDisabled, setIsContinueButtonDisabled] = (0, react_1.useState)(false);
    const accessToken = (0, auth_1.useSelector)(state => state === null || state === void 0 ? void 0 : state.accessToken);
    const selectUserTypeRoute = `${router_1.Route.Base}/${router_1.Route.ProfileSurvey}/${router_1.Route.SelectUserType}`;
    const missingProfileRoute = `${router_1.Route.Base}/${router_1.Route.ProfileSurvey}/${router_1.Route.MissingProfile}`;
    (0, react_1.useEffect)(() => {
        dispatch((0, Progress_1.setCurrentPage)(0));
        dispatch((0, Progress_1.setCanGoNext)(true));
        dispatch((0, Progress_1.setNextRoute)(selectUserTypeRoute));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch function should not be changed
    }, []);
    (0, react_1.useEffect)(() => {
        //If user is already authenticated, hide redeem code popover.
        if (accessToken) {
            storage === null || storage === void 0 ? void 0 : storage.put('shouldShowRedeemCodePopover', 'false');
        }
        const hasUserKind = (user === null || user === void 0 ? void 0 : user.kind) && (user === null || user === void 0 ? void 0 : user.kind) !== '-';
        if (hasUserKind && (user === null || user === void 0 ? void 0 : user.identifier)) {
            storage === null || storage === void 0 ? void 0 : storage.put('shouldShowUserSurvey', 'false');
            navigate('/hub');
        }
        else if (!hasUserKind && (user === null || user === void 0 ? void 0 : user.identifier)) {
            navigate(missingProfileRoute);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.identifier,
        missingProfileRoute,
        selectUserTypeRoute,
        storage,
        userOnboarding,
    ]);
    const onGoNext = () => {
        /**
         * Disables continue button to prevent multiple clicks
         */
        setIsContinueButtonDisabled(true);
        storage === null || storage === void 0 ? void 0 : storage.put('shouldShowUserSurvey', 'true');
        navigate(selectUserTypeRoute, { state: { canGoBack: true } });
    };
    /**
     * Opens login interface without closing the survey
     */
    const onShowLoginClick = () => {
        auth === null || auth === void 0 ? void 0 : auth.authenticate();
        navigate(`${auth_1.Route.Base}/${auth_1.Route.InterimScreen}/${auth_1.Route.InterimScreenOpen}`, {
            state: {
                process: auth_1.AuthProcess.SignIn,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(SurveyPageContentTemplate_1.SurveyPageContentTemplate, { Image: welcome_page_image_svg_1.default, content: (0, jsx_runtime_1.jsxs)(RightContainer, { children: [(0, jsx_runtime_1.jsx)(StyledTitle, { children: t(i18n_1.Strings.userOnboarding.welcomePage.title) }), (0, jsx_runtime_1.jsx)(StyledSubtitle, { children: t(i18n_1.Strings.userOnboarding.welcomePage.subtitle) }), (0, jsx_runtime_1.jsxs)(ButtonsContainer, { children: [(0, jsx_runtime_1.jsx)(StyledSecondaryButton, { onClick: onShowLoginClick, children: t(i18n_1.Strings.userOnboarding.welcomePage.alreadyHaveProfile) }), (0, jsx_runtime_1.jsx)(PrimaryButton_1.PrimaryButton, { onClick: onGoNext, disabled: isContinueButtonDisabled, children: t(i18n_1.Strings.userOnboarding.welcomePage.createProfile) })] })] }), "data-e2e": 'WelcomePageContent_SurveyPageContentTemplate' }));
}
const WelcomePageContentWithProviders = (0, hocs_1.withUserOnboardingProvider)((0, storage_1.withStorageProvider)((0, withDelayedAppearance_1.withDelayedAppearance)(WelcomePageContent, 300, 200)));
exports.WelcomePageContent = WelcomePageContentWithProviders;
const RightContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;

  ${mediaQueries_1.device.desktop `
    max-height: 625px;
  
    align-items: flex-start;
  `};
`;
const StyledTitle = (0, styled_components_1.default)(Title_1.Title) `
  margin-bottom: 16px;

  ${mediaQueries_1.device.desktop `
    height: 164px;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    
    text-align: left;
    margin-bottom: 40px;
  `}
`;
const StyledSubtitle = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  ${mediaQueries_1.device.desktop `
    height: 72px;
    
    text-align: left;
  `}
`;
const StyledSecondaryButton = (0, styled_components_1.default)(SecondaryButton_1.SecondaryButton) `
  margin-bottom: 16px;

  ${mediaQueries_1.device.mobileLandscape `
    margin-bottom: 0;
    margin-right: 16px;
  `};

  ${mediaQueries_1.device.desktop `
    margin-bottom: 16px;
    margin-right: 0;
  `};
`;
const ButtonsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin-top: auto;
  width: 100%;
  align-items: center;
  justify-content: center;

  ${mediaQueries_1.device.mobileLandscape `
    flex-direction: row;
  `};

  ${mediaQueries_1.device.desktop `
    flex-direction: column;
  `};
`;
